export default __webpack_public_path__ + "static/media/logo_g7spr.43d0ff35.svg";